export const EXPANDED_HEADER = 176;
export const COLLAPSED_HEADER = 55;
export const ROW_HEIGHT = COLLAPSED_HEADER;

export const MAX_PULL_DOWN = 150;
export const RESISTANCE_START = 0.5;
export const RESISTANCE_FACTOR = 1;
